import React, { useState } from 'react';
import { MdAttachMoney, MdList, MdOutlineSummarize } from 'react-icons/md';
import { VscSearch } from 'react-icons/vsc';
import { GiPayMoney } from 'react-icons/gi';
import { BsFileEarmarkPlus } from 'react-icons/bs';
import Header from '../../../layouts/Header';
import HeaderNavButton from '../../../helpers/buttons/HeaderNavButton';
import Filter from '../../../helpers/filter/Filter';
import { Outlet } from 'react-router-dom';

export default function Payables() {
  const [filterValue, setFilterValue] = useState('');
  const navButtons = [
    { to: 'outstanding', icon: MdList, label: 'Outstanding Payables' },
    { to: 'search', icon: VscSearch, label: 'Search Payables' },
    { to: 'summary', icon: MdOutlineSummarize, label: 'A/P Summary' },
    { to: 'apply-payments', icon: GiPayMoney, label: 'Apply Payments' },
    { to: 'payments', icon: MdAttachMoney, label: 'View Payments' },
    { to: 'create-bill', icon: BsFileEarmarkPlus, label: 'Create Bill' },
    { to: 'bill-payables', icon: GiPayMoney, label: 'Bill Payables' },
  ];

  return (
    <>
      <h1>Payables</h1>
      <Header>
        <div>
          {navButtons.map(button => (
            <HeaderNavButton
              key={button.to}
              to={button.to}
              icon={button.icon}
              label={button.label}
            />
          ))}
        </div>
        <div>
          <Filter
            filterValue={filterValue}
            setFilterValue={setFilterValue}
            placeholder="Filter payables"
          />
        </div>
      </Header>
      <Outlet context={filterValue} />
    </>
  );
}
